import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 40px;
  height: 52px;
  align-items: center;
  font-size: 18px;
  color: black;
  font-weight: bold;
  box-sizing: border-box;
  background-color: #f6f5f5;
  width: 100%;
`;

function PageHeader({ children, header }: IPageHeader) {
  return (
    <Wrapper>
      {header}
      {children}
    </Wrapper>
  );
}

export interface IPageHeader {
  header: string;
  children?: any;
}

export default PageHeader;
